export default class Question {
    constructor(id, text, answers = []) {
        this.id = id.toString();
        this.text = text;
        this.answers = answers;
    }

    getId() {
        return this.id;
    }

    getText() {
        return this.text;
    }

    getAnswers() {
        return this.answers;
    }

    addAnswer(answer) {
        this.answers.push(answer);
    }
}

Question.prototype.toString = function() {
    return this.text;
}
